import { CalendarIcon } from "lucide-react";
import { Button } from "../buttons/shadcn-button";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { Calendar } from "../calendar/Calendar";
import moment from "moment";

type DatePickerProps = {
  value?: Date;
  onChange: (date: Date | undefined) => void;
  placeholder?: string;
};

export function DatePicker({ value, onChange, placeholder }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-[240px] justify-start text-left font-normal"
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {value ? (
            moment(value).format("LL")
          ) : (
            <span>{placeholder || "Select a date"}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Calendar
          mode="single"
          selected={value}
          onSelect={onChange}
          captionLayout="dropdown"
        />
      </PopoverContent>
    </Popover>
  );
}
